import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { fetchAdAccount, reset } from 'features/account/accountSlice'

const useAdAccountLogin = () => {
  const dispatch = useDispatch()
  const { accountId } = useParams()
  useEffect(() => {
    if (accountId) {
      dispatch(fetchAdAccount(accountId))
    }
  }, [dispatch, accountId])
  useEffect(
    () => () => {
      dispatch(reset())
    },
    [dispatch]
  )
}
export default useAdAccountLogin
